import { Navigate, useParams } from 'react-router-dom';

export function TransferLegacyContractRedirect() {
  const { id } = useParams();
  return <Navigate to={`/gestion-transferts/tarification/contrats/${id}`} replace />;
}

export function TransferLegacyPromotionRedirect() {
  const { id } = useParams();
  return <Navigate to={`/gestion-transferts/tarification/actions-commerciales/${id}`} replace />;
}

export function TransferLegacyExtraRedirect() {
  const { id } = useParams();
  return <Navigate to={`/gestion-transferts/tarification/extras/${id}`} replace />;
}

export function TransferLegacyRuleRedirect() {
  const { id } = useParams();
  return <Navigate to={`/gestion-transferts/configuration/politiques/regle/${id}`} replace />;
}
